import React, { useEffect, useRef, useState } from "react";
import Modal from "../modal-new";
import moment from "moment";
import round from "lodash/round";
import { formattedTarget } from "../../utils/actuals";
import { S3_CDN_DOMAIN } from "../../constants";

export const JWPlayerMultipleVideos = ({
  firstMedia,
  secondMedia,
  athlete,
  locals,
}) => {
  const [range, setRange] = useState(0);
  const [showPlayState, setShowPlayState] = useState(true);
  const [maxDuration, setMaxDuration] = useState(60);
  const [firstVideoDuration, setFirstVideoDuration] = useState(60);
  const [secondVideoDuration, setSecondVideoDuration] = useState(60);

  const firstVideo = useRef(null);
  const secondVideo = useRef(null);

  const firstMediaJson = JSON.parse(firstMedia);
  const secondMediaJson = JSON.parse(secondMedia);
  const formatedDays = ["01", "02", "03", "04", "05", "06", "07", "08", "09"];
  const userMetrics = locals.activeUser.units === "imperial" ? "lb" : "kg";
  const precision = locals.activeUser.units === "metric" ? 2 : 1;
  const firstLoad =
    firstMediaJson.outcomes && firstMediaJson.outcomes.outcome.load
      ? `${round(
          locals.fromMetric(
            firstMediaJson.outcomes.outcome.load,
            locals.activeUser.units
          ),
          precision
        )} ${userMetrics}`
      : 0;
  const secondLoad =
    secondMediaJson.outcomes && secondMediaJson.outcomes.outcome.load
      ? `${round(
          locals.fromMetric(
            secondMediaJson.outcomes.outcome.load,
            locals.activeUser.units
          ),
          precision
        )} ${userMetrics}`
      : 0;

  const athleteName = locals.athlete
    ? locals.athlete.name
    : locals.activeUser.name;

  const firstVideoOriginal = firstMediaJson.videoOriginal?.replace(
    /\.[^/.]+$/,
    ".mp4"
  );
  const secondVideoOriginal = secondMediaJson.videoOriginal?.replace(
    /\.[^/.]+$/,
    ".mp4"
  );

  const firstSrc = `${S3_CDN_DOMAIN}exercise_set_videos/${
    firstMediaJson.uploaderId || firstMediaJson.exercise.user || athlete
  }/${firstVideoOriginal}`;
  const secondSrc = `${S3_CDN_DOMAIN}exercise_set_videos/${
    secondMediaJson.uploaderId || secondMediaJson.exercise.user || athlete
  }/${secondVideoOriginal}`;

  const play = () => {
    setShowPlayState(false);
    firstVideo.current?.play();
    secondVideo.current?.play();
  };

  const pause = () => {
    setShowPlayState(true);
    firstVideo.current?.pause();
    secondVideo.current?.pause();
  };

  const stop = () => {
    if (!firstVideo.current || !secondVideo.current) return;

    firstVideo.current.pause();
    secondVideo.current.pause();

    firstVideo.current.currentTime = 0;
    secondVideo.current.currentTime = 0;
  };

  const rangeInputSlider = () => {
    const rangeThumb = document.getElementById("range-thumb"),
      // rangeNumber = document.getElementById('range-number'),
      rangeLine = document.getElementById("range-line"),
      rangeInput = document.getElementById("range-input");
    // Insert the value of the input range
    //   rangeNumber.textContent = rangeInput.value;

    // Calculate the position of the input thumb
    // rangeInput.value = 50, rangeInput.max = 100, (50 / 100 = 0.5)
    // rangeInput.offsetWidth = 248, rangeThumb.offsetWidth = 32, (248 - 32 = 216)
    const thumbPosition = rangeInput.value / rangeInput.max,
      space = rangeInput.offsetWidth - rangeThumb.offsetWidth;

    // We insert the position of the input thumb
    // thumbPosition = 0.5, space = 216 (0.5 * 216 = 108)
    rangeThumb.style.left = thumbPosition * space + "px";

    // We insert the width to the slider with the value of the input value
    // rangeInput.value = 50, ancho = 50%
    rangeLine.style.width = thumbPosition * 100 + "%";
  };

  const handleChange = (event) => {
    if (!firstVideo.current || !secondVideo.current) return;

    const value = parseInt(event.target.value);
    setRange(value);

    firstVideo.current.currentTime = value;
    secondVideo.current.currentTime = value;
    rangeInputSlider();
    // We call the range input
  };
  useEffect(() => {
    if (process.browser && window && window.jwplayer) {
      setup("firstVideo", firstMediaJson.videoId);
      setup("secondVideo", secondMediaJson.videoId);
      jwplayer("firstVideo").on("play", function () {
        setFirstVideoDuration(jwplayer("firstVideo").getDuration());
      });
      jwplayer("secondVideo").on("play", function () {
        setSecondVideoDuration(jwplayer("secondVideo").getDuration());
      });
    }
  }, []);

  useEffect(() => {
    if (firstVideoDuration !== 60 || secondVideoDuration !== 60) {
      const longestDuration =
        firstVideoDuration > secondVideoDuration
          ? parseInt(firstVideoDuration)
          : secondVideoDuration > firstVideoDuration
          ? parseInt(secondVideoDuration)
          : parseInt(firstVideoDuration);

      setMaxDuration(longestDuration);
    }
  }, [firstVideoDuration, secondVideoDuration]);

  return (
    <Modal className="jwplayer-multi-modal" title={"Compare Videos"}>
      <div className={"body"}>
        <section className="videos-wrapper">
          <article>
            <header>
              <p className="s1">
                {" "}
                {formatedDays.includes(
                  moment(firstMediaJson.date, "YYYYMMDD").format("DD")
                )
                  ? moment(firstMediaJson.date, "YYYYMMDD").format(
                      "MMM D, YYYY"
                    )
                  : moment(firstMediaJson.date, "YYYYMMDD").format(
                      "MMM DD, YYYY"
                    )}
              </p>
              <p className="p4">
                <span>{firstMediaJson.displayName} </span>
                <span> | </span>
                <span>
                  {formattedTarget(
                    firstMediaJson.outcomes
                      ? firstMediaJson.outcomes.outcome
                      : {},
                    firstMediaJson.exercise.type === "primary" ||
                      firstMediaJson.exercise.type === "secondary",
                    firstMediaJson.set.percentRepMax
                      ? firstMediaJson.set.percentRepMax
                      : undefined,
                    locals.activeUser.units,
                    firstLoad,
                    locals.activeUser.intensityMeasure,
                    locals.activeUser.intensityMeasure === "rpe" ? false : true,
                    true
                  )}{" "}
                  <span> | </span>
                  (Set #{firstMediaJson.setNumber})
                </span>
              </p>
            </header>
            <video
              ref={firstVideo}
              width="100%"
              height="478"
              controls
              controlsList="nodownload"
              disablePictureInPicture
              src={firstSrc}
              onPlay={(e) => setFirstVideoDuration(e.currentTarget.duration)}
            />
          </article>
          <article>
            <header>
              <p className="s1">
                {" "}
                {formatedDays.includes(
                  moment(secondMediaJson.date, "YYYYMMDD").format("DD")
                )
                  ? moment(secondMediaJson.date, "YYYYMMDD").format(
                      "MMM D, YYYY"
                    )
                  : moment(secondMediaJson.date, "YYYYMMDD").format(
                      "MMM DD, YYYY"
                    )}
              </p>
              <p className="p4">
                <span>{secondMediaJson.displayName} </span>
                <span> | </span>
                <span>
                  {formattedTarget(
                    secondMediaJson.outcomes
                      ? secondMediaJson.outcomes.outcome
                      : {},
                    secondMediaJson.exercise.type === "primary" ||
                      secondMediaJson.exercise.type === "secondary",
                    secondMediaJson.set.percentRepMax
                      ? secondMediaJson.set.percentRepMax
                      : undefined,
                    locals.activeUser.units,
                    secondLoad,
                    locals.activeUser.intensityMeasure,
                    locals.activeUser.intensityMeasure === "rpe" ? false : true,
                    true
                  )}{" "}
                  {locals.activeUser.units === "metric" ? "kg" : "lb"}
                  <span> | </span>
                  (Set #{secondMediaJson.setNumber})
                </span>
              </p>
            </header>
            <video
              ref={secondVideo}
              width="100%"
              height="478"
              controls
              controlsList="nodownload"
              disablePictureInPicture
              src={secondSrc}
              onPlay={(e) => setSecondVideoDuration(e.currentTarget.duration)}
            />
          </article>
        </section>
        <section role="video-controls-wrapper">
          <p>Common controls:</p>

          <div className="range-wrapper">
            <div class="range__content">
              <div className="range__slider">
                <div class="range__slider-line" id="range-line"></div>
              </div>
              <div className="range__thumb" id="range-thumb"></div>
              <input
                type="range"
                value={range}
                onChange={handleChange}
                max={maxDuration}
                min="0"
                class="range__input"
                id="range-input"
              />
            </div>
          </div>
          <div role="buttons-container">
            <button
              data-button-type="secondary"
              data-icon
              onClick={showPlayState ? () => play() : () => pause()}
            >
              <img
                src={
                  showPlayState
                    ? "/img/new-icons/play-white.svg"
                    : "/img/svg/pause-alt.svg"
                }
                {...(!showPlayState && { className: "pause" })}
                alt="play"
              />
              {showPlayState ? "Play" : "Pause"}
            </button>

            <button data-button-type="secondary" onClick={stop}>
              <img
                src="/img/new-icons/vuesax-linear-stop-circle.svg"
                alt="play"
              />
            </button>
          </div>
        </section>
      </div>
    </Modal>
  );
};
